export default __webpack_public_path__ + "static/media/qhmovie-signin2.cd73ba5c.png";